import { render, staticRenderFns } from "./BugReportModal.vue?vue&type=template&id=657f7890"
import script from "./BugReportModal.vue?vue&type=script&lang=js"
export * from "./BugReportModal.vue?vue&type=script&lang=js"
import style0 from "./BugReportModal.vue?vue&type=style&index=0&id=657f7890&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports